import store from "@/base/store";
import wishlist from "./wishlist";
store.registerModule("wishlist", wishlist);

export default store;
